module.exports = __webpack_public_path__ + "img/001.6f435562.png";